import React from 'react';
import i18n from 'rcx_i18n';
import CircularProgress from '@material-ui/core/CircularProgress';
import { StyledLoadingPageContainer, StyledLoadingPageText } from './index.styled';

const LoadingPage = () => {
    return (
        <StyledLoadingPageContainer>
            <CircularProgress size={24} />
            <StyledLoadingPageText>{i18n.t("loading_page_text")}</StyledLoadingPageText>
        </StyledLoadingPageContainer>
    );
};

export default LoadingPage;
